import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { ListWhatsAppSenderConfigurationMasterResponse } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { map, catchError, throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmsSenderConfigService {
  constructor(private http: HttpClient) {}
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  CreateSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, payload:any): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`;
        break;
    }
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number, payload:any): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`;
        break;
    }
    return this.http.put(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ListSmsSenderConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`
        break;
    }
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ActiveSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master/${configId}/mark_as_active`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master/${configId}/mark_as_active`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master/${configId}/mark_as_active`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master/${configId}/mark_as_active`;
        break;
    }
    return this.http.post(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  InActiveSMSSenderConfigMaster(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number, configId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master/${configId}/mark_as_inactive`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master/${configId}/mark_as_inactive`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master/${configId}/mark_as_inactive`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master/${configId}/mark_as_inactive`;
        break;
    }
    return this.http.post(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
  
}
